import { Link, useLocation, useNavigate } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Button } from "reactstrap";

const formatLabel = (value) =>
  value.replace(/[-_]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

const Breadcrumbs = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // full path segments
  const pathnames = location.pathname.split("/").filter(Boolean);

  // ❗ remove first segment (admin)
  const breadcrumbPaths = pathnames.slice(1);

  const canGoBack = breadcrumbPaths.length > 0;

  return (
    <Breadcrumb className="mb-0 app-breadcrumb" style={{ background: "transparent" }}>
      
      {/* Back button */}
      <BreadcrumbItem>
        <Button
          color="link"
          className="p-0"
          disabled={!canGoBack}
          onClick={() => navigate(-1)}
          style={{
            textDecoration: "none",
            fontSize: "14px",
            color: "#6c757d",
          }}
        >
          <i className="fa fa-arrow-left" />
        </Button>
      </BreadcrumbItem>

      {breadcrumbPaths.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 2).join("/")}`;
        const isLast = index === breadcrumbPaths.length - 1;

        return isLast ? (
          <BreadcrumbItem key={to} active>
            {formatLabel(value)}
          </BreadcrumbItem>
        ) : (
          <BreadcrumbItem key={to}>
            <Link to={to}>{formatLabel(value)}</Link>
          </BreadcrumbItem>
        );
      })}
    </Breadcrumb>
  );
};

export default Breadcrumbs;
